<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     设备列表
  +---------------------------------------------------------------------------------------
-->
<template>
  <div class="rms-equip" :class="{ 'is-collapse': collapse, 'fold': tagManagerFold }">
    <div class="tag-area" :class="!collapse && 'no-collapse'">
      <tag-manager
        ref="tagManager"
        :foot="recycle"
        v-model="query.tagid"
        type="equip"
        @toggle="handleTagManagerToggle"
        @change="fetchData(1)"
        @update="fetchData()"
        @delete="fetchData()"
        @group="hangleGroup"
      >
        <div slot="recycle">
          <div role="button" @click="recycle_bin = true">
            <span class="iconfont icon-delete" :class="!tagManagerFold && 'mr-sm'"></span>
            <span v-if="!tagManagerFold">设备回收站</span>
          </div>
        </div>
      </tag-manager>
    </div>

    <div class="table-area">
      <div class="filter-container">
        <div class="filter-box">
          <span class="filter-item">
            <f-radio-btn-group v-model="query.equip_status" :groups="equipEventTypeArr" @change="fetchData(1)" />
          </span>
          <div class="filter-item sm">
            <f-dev-selector v-model="query.devid" :show-not-load="true" placeholder="选择模型" width="160" @change="fetchData(1)" />
          </div>
          <div class="filter-item sm">
            <f-search-input v-model="query.keyword" width="200" placeholder="搜索" prefix-icon="el-icon-search" clearable @change="fetchData(1)" />
          </div>
        </div>
        <div class="toolbox">
          <el-button type="primary" @click="event_manage = true" plain>
            <span class="iconfont icon-event-management mr-xs"></span>事件中心
          </el-button>
          <el-button type="success" @click="toData" plain>
            <span class="iconfont icon-download mr-xs"></span>数据中心
          </el-button>
          <f-sort-selector v-model="query.sort" :options="sortOptions" class="ml-sm" @change="fetchData(1)" />
          <div class="ml-sm switch-box flex align-items-center justify-content-space-around">
            <span class="iconfont icon-list-mode text-muted" :class="displayMode === 'list' && 'active'" @click="switchMode('list')"></span>
            <span class="iconfont icon-card-mode text-muted" :class="displayMode === 'card' && 'active'" @click="switchMode('card')"></span>
          </div>
        </div>
      </div>
      <el-card v-loading="loading" v-if="displayMode === 'list'" shadow="never" class="card">
        <el-table ref="listTable" :data="equips" tooltip-effect="dark" @selection-change="handleSelectionChange">
          <el-table-column type="selection" :selectable="selectable" width="50" />
          <el-table-column width="60">
            <template slot-scope="scope">
              <f-equip-avatar :equip="scope.row" />
            </template>
          </el-table-column>

          <el-table-column label="名称" min-width="220" show-overflow-tooltip>
            <div slot-scope="scope">
              <div class="flex">
                <f-equip-name class="font-md" :equip="scope.row" />
                <tag-panel2 :ref="'tagPanel' + scope.row.equipid" type="equip" class=""
                  :unique-key="scope.row.equipid" :title="scope.row.name" :tags="scope.row.tags"
                  @update="handleTagPanelUpdate" />
              </div>
              <div v-if="scope.row.groups" class="text-muted font-sm" style="line-height: 16px;">
                {{ scope.row.groups.title }}
                <span v-if="scope.row.groups.children && scope.row.groups.children.length">
                  {{ ' / '+scope.row.groups.children[0].title }}
                  <span
                    v-if="scope.row.groups.children[0].children && scope.row.groups.children[0].children.length"
                  >{{ ' / '+scope.row.groups.children[0].children[0].title }}</span>
                </span>
              </div>
              <div v-if="scope.row.remark" class="text-muted font-sm" style="line-height: 16px;">{{ scope.row.remark }}</div>
            </div>
          </el-table-column>
          <el-table-column label="状态" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <div v-if="scope.row.expired" class="mt-xs text-danger ellipsis">
                <div v-if="now - scope.row.expire_day > oneDay">{{ scope.row.expire_day | parseTime('{y}/{m}/{d}') }} 服务已到期</div>
                <div v-else>{{ scope.row.expire_day | formatTime }} 服务已到期</div>
              </div>
              <span
                v-else
                :class="{ 'text-muted': !scope.row.is_online, 'text-danger': scope.row.is_online && scope.row.is_alarm, 'text-blue': scope.row.is_online && !scope.row.is_alarm && !scope.row.is_running, 'text-success': scope.row.is_online && !scope.row.is_alarm && scope.row.is_running }"
              >{{ scope.row.status }}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="当前值" min-width="100" align="right">
            <template slot-scope="scope">
              <span v-if="!scope.row.expired" :class="scope.row.sen_type == 2 ? 'font-lg' : 'font-2x'">{{ scope.row.current_value === '' ? '--' : scope.row.current_value }}</span>
            </template>
          </el-table-column>
          <el-table-column width="60" align="left">
            <template slot-scope="scope">
              <span
                v-if="!scope.row.expired && scope.row.current_value !== ''"
                class="text-muted"
                style="margin-left: -10px;"
              >{{ scope.row.unit_value }}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="最近通讯时间" min-width="140">
            <template slot-scope="scope">
              <span>{{ scope.row.last_parser_time | parseTime('{y}/{m}/{d} {h}:{i}:{s}') }}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="模型" min-width="120">
            <template slot-scope="scope">
              <FDevName :dev="{ dev_name: scope.row.dev_name, devid: scope.row.devid }" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="medium" @click="toEquipDetail(scope.row.equipid)">查看</el-button>
              <el-dropdown trigger="click" placement="bottom-start" class="ml-sm">
                <el-button type="text">更多</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="editRemark(scope.row)">备注</el-dropdown-item>
                  <el-dropdown-item @click.native="moveGroup(scope.row)">移动组</el-dropdown-item>
                  <el-dropdown-item @click.native="makeTag(scope.row)">打标签</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <template slot="append">
            <div class="foot-menu flex" :class="[!collapse && 'active', !tagManagerFold && 'fold']">
              <div class="foot flex1">
                <f-table-footer :list="equips" :selection="multiSelection" checkbox @toggle="toggleAll">
                  <span class="mr-sm" v-if="multiSelection.length">已选 <span class="text-success">{{multiSelection.length}}</span> 台设备</span>

                  <el-button
                    type="success"
                    size="mini"
                    :plain="multiSelection.length === 0"
                    :disabled="multiSelection.length === 0"
                    @click="moveGroups"
                  >移动分组</el-button>
                  <el-button
                    type="success"
                    size="mini"
                    :plain="multiSelection.length === 0"
                    @click="loadDev"
                  >加载模型</el-button>
                  <el-button
                    type="success"
                    size="mini"
                    :plain="multiSelection.length === 0"
                    :disabled="multiSelection.length === 0"
                    @click="shareMulti"
                  >分享移交</el-button>
                  <template slot="right">
                    <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
                  </template>
                </f-table-footer>
              </div>
            </div>
          </template>

          <div slot="empty" class="flex-center column pb-md">
            <div class="flex-center mt-hg">
              <img src="../../assets/no-data.png" alt class="no-data" />
            </div>
            <el-button type="warning" plain size="small" @click="toDoc">了解远程监控</el-button>
          </div>
        </el-table>
      </el-card>
      <div v-loading="loading" v-else>
        <el-card v-if="equips.length == 0" shadow="never" class="card">
          <div class="flex-center column pb-md">
            <div class="flex-center mt-hg">
              <img src="../../assets/no-data.png" alt class="no-data" />
            </div>
            <el-button type="warning" plain size="small" @click="toDoc">了解远程监控</el-button>
          </div>
        </el-card>

        <div v-else class="card_mode flex">
          <div v-for="item_card_mode in equips" :key="item_card_mode.equipid" @click="toDetail(item_card_mode)" class="card_item flex column"
          :class="[item_card_mode.checked && 'card_item_active',
            item_card_mode.is_online == 1 && !item_card_mode.expired && 'online',
            item_card_mode.is_online == 1 &&item_card_mode.is_running == 1 && !item_card_mode.expired && 'running',
            item_card_mode.is_online == 1 && item_card_mode.is_alarm == 1 && !item_card_mode.expired && 'alarm']">
            <div class="item_head hd">
              <div class="flex">
                <div class="flex bd" style="width: calc(100% - 20px)">
                  <f-equip-name class="font-md hd" :equip="item_card_mode" />
                  <tag-panel
                    :ref="'tagPanel' + item_card_mode.equipid"
                    type="equip"
                    :unique-key="item_card_mode.equipid"
                    :title="item_card_mode.name"
                    :tags="item_card_mode.tags"
                    @update="handleTagPanelUpdate"
                    class="bd ellipsis ml-sm"
                    style="margin-top: 2px;"
                  />
                </div>
                <!-- 阻止事件冒泡 -->
                <div class="more ft" @click.stop="() => {}">
                  <el-dropdown trigger="hover" placement="bottom-start">
                    <span class="iconfont icon-more"></span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="editRemark(item_card_mode)">备注</el-dropdown-item>
                      <el-dropdown-item @click.native="moveGroup(item_card_mode)">移动组</el-dropdown-item>
                      <el-dropdown-item @click.native="makeTag(item_card_mode)">打标签</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
              <FDevName :dev="{ dev_name: item_card_mode.dev_name, devid: item_card_mode.devid }" class="dev_name" />
            </div>
            <div class="bd item_body" style="height: 100%;">

              <div v-if="item_card_mode.is_online" class="flex justify-content-flex-end current-value align-items-center" style="height: 100%;">
                <div>
                  <span v-if="!item_card_mode.expired">
                    <span style="font-size: 36px;margin-right: 10px;" :class="hasChinese(item_card_mode.current_value) ? 'font-30' : ''">{{ item_card_mode.current_value === '' ? '--' : item_card_mode.current_value }}</span>
                    <span v-if="item_card_mode.current_value" style="margin-right: 10px;">{{ item_card_mode.unit_value }}</span>
                  </span>
                </div>
              </div>
              <div v-else class="flex justify-content-center align-items-center" style="height: 100%;">
                <img v-if="!item_card_mode.expired" src="../../assets/no-net.png" alt="" style="width: 70px;height: 70px;">
                <img v-else style="width: 70px;height: 70px;" src="../../assets/sandglass.svg" />
              </div>
            </div>
            <div class="ft equip-status">
              <div class="flex align-items-center ellipsis">
                <img v-if="item_card_mode.is_online == 0 && !item_card_mode.expired" src="../../assets/status-offline.jpg" class="icon_status"/>
                <img v-else-if="item_card_mode.is_alarm == 1 && !item_card_mode.expired" src="../../assets/status-alarming-list.gif" class="icon_status"/>
                <img v-else-if="item_card_mode.is_running == 1 && !item_card_mode.expired" src="../../assets/status-running-list.gif" class="icon_status"/>
                <img v-else-if="item_card_mode.is_online == 1 && !item_card_mode.expired" src="../../assets/status-online-list.gif" class="icon_status"/>
                <div class="ellipsis">
                  <span v-if="item_card_mode.expired" class="text-danger">{{ item_card_mode.expire_day | formatTime }} 服务已到期</span>
                  <span v-else-if="item_card_mode.is_online == 0" class="text-muted">
                    <span v-if="item_card_mode.last_parser_time">离线时间：{{ item_card_mode.last_parser_time | parseTime('{y}/{m}/{d} {h}:{i}:{s}') }}</span>
                    <span v-else>{{ item_card_mode.status }}</span>
                  </span>
                  <span v-else style="max-width: 245px;" class="ellipsis" :class="{'text-danger': item_card_mode.is_alarm == 1}">{{ item_card_mode.is_alarm == 1 ? item_card_mode.last_alarm_title : item_card_mode.status }}</span>
                </div>
              </div>
              <!-- 阻止事件冒泡 -->
              <div @click.stop="() => {}">
                <el-checkbox v-model="item_card_mode.checked" class="checkbox_item" @change="handleCustomChange(item_card_mode)"></el-checkbox>
              </div>
            </div>
          </div>

        </div>
        <div class="foot-menu flex" :class="[!collapse && 'active', !tagManagerFold && 'fold']">
          <div class="foot flex1">
            <f-table-footer :list="equips" :selection="multiSelection" checkbox @toggle="toggleAllCustom">
              <span class="mr-sm" v-if="multiSelection.length">已选 <span class="text-success">{{multiSelection.length}}</span> 台设备</span>
              <el-button
                type="success"
                size="mini"
                :plain="multiSelection.length === 0"
                :disabled="multiSelection.length === 0"
                @click="moveGroups"
              >移动分组</el-button>
              <el-button
                type="success"
                size="mini"
                :plain="multiSelection.length === 0"
                @click="loadDev"
              >加载模型</el-button>
              <el-button
                type="success"
                size="mini"
                :plain="multiSelection.length === 0"
                :disabled="multiSelection.length === 0"
                @click="shareMulti"
              >分享移交</el-button>

              <template slot="right">
                <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
              </template>
            </f-table-footer>
          </div>
        </div>
      </div>
    </div>

    <event-manage v-if="event_manage" :show.sync="event_manage"></event-manage>
    <rms-equip-share ref="equipShare" :show.sync="equipShareShow" :equips="shareEquips" :title="activeEquip.name"
      @change="shareChange" />
    <ap-recycle-bin v-if="recycle_bin" :show.sync="recycle_bin" />
    <MoveGroup v-if="group_show" :show.sync="group_show" :equipids="equipids" :groupid="groupid" :title="name" @check="updateGroupid" @success="moveSuccess"/>
    <MakeTag v-if="make_tag_show" :show.sync="make_tag_show"  type="equip" :unique-key="equipid" :title="name" :tags="tags"
      @update="handleTagPanelUpdate"/>
    <DevPicker v-if="load_dev_show" :show.sync="load_dev_show" :list="multiSelection" @change="fetchData" @share="openEquipShare"/>
  </div>
</template>

<script>
import Vue from "vue";
import { getEquipListApi, equipEditApi } from "@/api/rms/rmsEquipApi";
import { getAllDevApi } from "@/api/dev/devApi";

export default {
  name: "RmsEquip",

  components: {
    RmsEquipShare: () => import("./components/RmsEquipShare"),
    EventManage: () => import("./components/EventManage"),
    TagPanel: () => import("@/views/fam/components/TagPanel"),
    TagPanel2: () => import("@/views/fam/components/TagPanel2"),
    ApRecycleBin: () => import("@/views/ap/components/ApRecycleBin"),
    TagManager: () => import("./components/TagManager"),
    MoveGroup: () => import("./components/MoveGroup"),
    MakeTag: () => import("./components/MakeTag"),
    DevPicker: () => import("./components/DevPicker"),
  },

  data() {
    return {
      statusArr: [
        { value: 1, title: "待接入" },
        { value: 2, title: "离线" },
        { value: 3, title: "在线" },
        { value: 4, title: "告警" },
        { value: 5, title: "运行" },
      ],
      sortOptions: [
        { value: 0, title: "最近创建" },
        { value: 1, title: "最早创建" },
        { value: 2, title: "按名称 A-Z" },
        { value: 3, title: "按名称 Z-A" },
      ],
      multiSelection: [],
      loading: false,
      query: {
        tagid: undefined,
        keyword: undefined,
        equip_status: Number(this.$route.query.status) || undefined,
        sort: undefined,
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
        devid: null,
        groupid: this.$store.state.commonStore.defaultGroupId,
      },
      equipEventTypeArr: [
        { value: 0, title: "全部", separate: true },
        { value: 2, title: "离线" },
        { value: 3, title: "在线" },
        { value: 5, title: "运行" },
        { value: 4, title: "告警" },
      ],
      equips: [],
      total: 0,
      devs: [],

      oneDay: 24 * 60 * 60,
      now: parseInt(new Date().getTime() / 1000),

      shareEquips: [],
      equipShareShow: false,

      activeEquip: {},
      recycle_bin: this.$route.query.recycle_bin ? true : false,
      event_manage: false,
      recycle: true,

      tagManagerFold: Number(
        localStorage.getItem(`__TAG_MANAGER_FOLD_EQUIP__`)
      ),
      group_show: false,
      equipids: [],
      groupid: null,
      make_tag_show: false,
      equipid: 0,
      tags: [],
      name: "",

      load_dev_show: false,
      displayMode: localStorage.getItem("__DISPLAY_MODE__") || "list",
    };
  },

  computed: {
    collapse() {
      return this.$store.state.commonStore.collapse;
    },
    updateTag() {
      return this.$store.state.memberStore.tagChange;
    },
    updateGroup() {
      return this.$store.state.memberStore.groupChange;
    },
  },

  watch: {
    updateTag(nval) {
      if (nval) {
        this.fetchData();
        this.$refs["tagManager"].fetchData();
      }
    },
    updateGroup(nval) {
      if (nval) {
        this.fetchData();
        this.$refs["tagManager"].fetchGroups();
      }
    },
  },

  created() {
    this.query = this.$utils.initListQuery(this.query, ["/rms/equip/detail"]);
    this.fetchDev();
    this.fetchData();
  },

  beforeRouteLeave(to, from, next) {
    this.$utils.saveListQuery(this.query);
    next();
  },

  methods: {
    toggleAll() {
      this.$refs.listTable.toggleAllSelection();
    },

    toggleAllCustom(val) {
      this.equips = this.equips.map((item) => {
        item.checked = val;
        return item;
      })
      if (val) {
        this.multiSelection = this.equips;
      } else {
        this.multiSelection = [];
      }
    },

    updateData(data) {
      const x = this.multiSelection
        .map((item) => item.equipid)
        .indexOf(data.equipid);
      this.equips.forEach((v, i) => {
        if (data.equipid === v.equipid) {
          Vue.set(this.equips, i, Object.assign({}, this.equips[i], data));
          if (x > -1) {
            this.$nextTick(() => {
              const index = this.multiSelection
                .map((item) => item.equipid)
                .indexOf(data.equipid);
              if (index > -1) {
                this.multiSelection.splice(index, 1, this.equips[i]);
              } else {
                this.multiSelection.push(this.equips[i]);
              }
              this.$refs.listTable.toggleRowSelection(this.equips[i], true);
            });
          }
        }
      });
    },

    fetchData(page) {
      if (page) this.query.pindex = page;
      this.loading = true;
      getEquipListApi(this.query).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.equips = res.data.list.map((i) => {
            if (i.is_online && i.is_alarm && i.is_running)
              i.status = "告警运行";
            if (i.is_online && i.is_alarm && !i.is_running) i.status = "告警";
            if (i.is_online && !i.is_alarm && i.is_running)
              i.status = "正常运行";
            if (i.is_online && !i.is_alarm && !i.is_running) i.status = "在线";
            i.checked = false;
            return i;
          });
          this.total = res.data.total;
          this.query.sort = res.data.sort;
          this.multiSelection = [];
        } else {
          this.$message.error(res.message);
        }
      });
    },

    fetchDev() {
      getAllDevApi().then((res) => {
        if (!res.errno) {
          this.devs = res.data.list;
        }
      });
    },

    switchMode(mode) {
      this.displayMode = mode;
      this.query.pindex = 1;
      localStorage.setItem("__DISPLAY_MODE__", mode);
      this.fetchData();
    },

    editRemark(row) {
      this.$prompt(`请输入备注信息`, row.name, {
        inputValue: row.remark,
        closeOnClickModal: false,
      })
        .then(({ value }) => {
          equipEditApi({ equipid: row.equipid, remark: value }).then((res) => {
            if (!res.errno) {
              this.fetchData();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          // 取消
        });
    },

    makeTag(row) {
      this.equipid = row.equipid;
      this.name = row.name;
      this.tags = row.tags;
      this.make_tag_show = true;
    },

    shareChange() {
      this.fetchData(this.query.pindex);
    },

    shareOne(row) {
      this.shareEquips = [row];
      this.equipShareShow = true;
    },

    shareMulti() {
      this.shareEquips = this.multiSelection;
      this.equipShareShow = true;
    },

    openEquipShare(e) {
      this.shareEquips = e;
      this.equipShareShow = true;
    },

    selectable(row) {
      return row;
    },

    handleSelectionChange(val) {
      this.multiSelection = val;
    },

    handleCustomChange() {
      this.multiSelection = this.equips.filter((i) => i.checked);
    },

    handleTagManagerToggle(val) {
      this.tagManagerFold = val;
    },
    handleTagPanelUpdate() {
      this.fetchData();
      this.$refs["tagManager"].fetchData();
    },

    toEquipDetail(equipid) {
      this.$router.push({
        name: "RmsEquipDetail",
        params: { equipid: equipid },
      });
    },

    toData() {
      this.$router.push("/rms/data");
    },

    toDoc() {
      window.open("https://wiki.frippler.com/#/docs/fs/fcs/12");
    },

    hangleGroup(val) {
      if (val || val === 0) {
        this.query.groupid = val;
      } else {
        delete this.query.groupid;
      }
      this.fetchData(1);
    },

    moveGroup(row) {
      this.group_show = true;
      this.equipids = [row.equipid];
      this.name = row.name;
      if (row.groupid) {
        this.groupid = row.groupid;
      } else {
        this.groupid = null;
      }
    },

    moveGroups() {
      this.equipids = this.multiSelection.map((item) => {
        return item.equipid;
      });
      this.name = "";
      this.groupid = null;
      this.group_show = true;
    },

    updateGroupid(val) {
      this.groupid = val;
    },

    moveSuccess() {
      this.fetchData();
      this.$refs.tagManager.fetchGroups();
    },

    loadDev() {
      this.load_dev_show = true;
    },

    toDetail(e) {
      this.$detail({type:'equip',id:e.equipid})
    },

    hasChinese(str) {
      // 正则表达式：匹配任意中文字符
      const chineseRegex = /[\u4e00-\u9fa5]/;
      // 使用 test 方法检测字符串
      return chineseRegex.test(str);
    },
  },
};
</script>

<style lang="scss" scoped>
.rms-equip {
  position: relative;
  .tag-area {
    position: fixed;
    left: 160px;
    top: 60px;
    height: calc(100% - 60px);
    width: 240px;
    background-color: #fff;
    &.no-collapse {
      border-bottom-left-radius: 20px;
    }
  }

  .table-area {
    padding-left: 240px;
    padding-bottom: 60px;
    box-sizing: border-box;
    /deep/ .card {
      margin-bottom: 20px;
      border: none;
    }
    .switch-box {
      width: 80px;
      height: 36px;
      background-color: #fff;
      border-radius: 5px;
      .icon-list-mode,
      .icon-card-mode {
        cursor: pointer;
        font-size: 25px;
      }
      .icon-list-mode.active,
      .icon-card-mode.active {
        color: #07c160;
      }
    }

    .card_mode {
      flex-wrap: wrap;
      .card_item {
        width: calc(20% - 20px);
        height: 192px;
        border-radius: 5px;
        box-sizing: border-box;
        // border: 1px solid transparent;
        margin: 10px;
        background-color: rgba(255, 255, 255, 1);
        padding: 10px;
        padding-bottom: 0px;
        &.online {
          // background: radial-gradient(0.6507746666666666% 0.9880539999999998% at 99.7% 99%, #D0E2F8,#F6F7F9);
          background: radial-gradient(circle 192px at 100% 100%, rgba(208,226,248,1) 0%,rgba(246,247,249,1) 98%);
          box-shadow: 0px 0px 15px 0px rgba(220, 223, 230, 1);
        }
        &.running {
          background: radial-gradient(circle 192px at 100% 100%, #D9FBE9,#F6F7F9);
          box-shadow: 0px 0px 15px 0px rgba(220, 223, 230, 1);
        }
        &.alarm {
          background: radial-gradient(circle 192px at 100% 100%, #FBDCDB,#F6F7F9);
          box-shadow: 0px 0px 15px 0px rgba(220, 223, 230, 1);
        }
        .item_head {
          height: 40px;
          .more {
            width: 24px;
            height: 24px;
            border-radius: 5px;
            transform: rotate(90deg);
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            .icon-more {
              font-size: 18px;
              display: none;
            }
            &:hover {
              background-color: #EEF0F5;
            }
          }
          .dev_name.el-link {
            font-size: 12px;
            color: #909399;
            &:hover {
              color: #07c160;
            }
          }
        }

        .equip-status {
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .icon_status {
            width: 24px;
            height: 24px;
            margin-right: 10px;
            border-radius: 5px;
          }
          .checkbox_item {
            display: none;
            margin-top: 2px;
          }
        }
      }
      .card_item:hover,.card_item.card_item_active {
        border: 1px solid rgba(7, 193, 96, 1);
        .item_head {
          margin-top: -1px;
          margin-left: -1px;
        }
        .current-value {
          margin-right: -1px;
          .font-30 {
            font-size: 30px;
          }
        }
        .equip-status {
          margin-bottom: -1px;
          margin-left: -1px;
        }
        .more .icon-more {
          display: block;
        }
        .checkbox_item {
          display: block;
        }
      }
    }
  }

  &.fold {
    .tag-area {
      width: 60px;
    }
    .table-area {
      padding-left: 60px;
    }
  }

  &.is-collapse {
    .tag-area {
      left: 60px;
    }
  }
}
/deep/ .sort {
  width: 80px;
}
.no-data {
  width: 200px;
  height: 200px;
}

.foot-menu {
  position: fixed;
  background-color: #fff;
  bottom: 0;
  left: 120px;
  width: calc(100% - 120px);
  z-index: 3;
  padding-left: 20px;

  &.active {
    left: 220px;
    width: calc(100% - 220px);
  }

  &.fold {
    left: 300px;
    width: calc(100% - 300px);
  }

  &.active.fold {
    left: 400px;
    width: calc(100% - 400px);
  }

  .foot {
    padding: 4px 30px 5px 20px;
    z-index: 2;

    &.active {
      padding-right: 130px;
    }
  }
}

.f-table-footer {
  margin: 0;
  height: 50px;
}
</style>
